import React from 'react';
import TextBlock from '../Components/TextBlock';
import Collaps from '../Components/Collaps';

const L1 = (props) => {
  return (
    <React.Fragment>
     <TextBlock name= 'Комплексні рішення в сфері реєстрації юридичних осіб' />
      
      <TextBlock name= 'Пакет "Базовий"'>
        <section className="s-text">
          
            До пакету входить:<br/>
            1) консультація відносно реєстрації юридичних осіб; <br/>
            2) консультацію з підбору системи оподаткування; <br/>
            3) перевірку найменування (ми перевіримо, чи відповідає назва майбутньої фірми вимогам законодавства, та чи не зареєстрована інша фірма з такою ж назвою; <br/>
            4) підбір КВЕД по основному виду діяльності; <br/>
            5) підготовку статутних документів і заяви на реєстрацію; <br/>
            6) подання документів державному реєстратору; <br/>
            7) постановку на облік в управлінні статистики; <br/>
            8) постановку на облік в податковій службі; <br/>
            9) реєстрацію платником податків на загальну систему оподаткування; <br/>
            11) отримання виписки про підприємство з ЄДР.
          
        </section>
        <section className="s-textb">
          Строк виконання 2-4 робочі дні. <br/>
          Вартість наших услуг – 3000 грн.* <br/>
          *Вартість послуги зазначено для фірм що реєструються за київською адресою і до складу засновників яких входить не більше 2х засновників,  якщо засновників  більше двох, то вартість збільшується на 500 грн. <br/>
          Додатково оплачуються послуги нотаріуса з нотаріального посвідчення статутних документів (вартість залежить від кількості засновників).
        </section>
      </TextBlock>


      <TextBlock name= 'Пакет "Базовий з ПДВ"'>
      <section className="s-text">
       
          При замовлені цього пакета, окрім послуг, зазначених в пакеті "Базовий", ви отримаєте: <br/>
          1) реєстрацію платником ПДВ чи платником єдиного податку;   <br/>
          2) витяг з реєстру платників податків; <br/>
       
      </section>
      <section className="s-textb">
        Строк виконання – до 10 робочих днів. <br/>
        Строк отримання статусу платника  ПДВ залежить від обраної системи оподаткування і може займати від 10 днів до 3х місяців. <br/>
        Вартість – 4000 грн. <br/>
         *Вартість послуги зазначено для фірм що реєструються за київською адресою і до складу засновників яких входить не більше 2х засновників,  якщо засновників  більше двох, то вартість збільшується на 500 грн. <br/>
         Додатково оплачуються послуги нотаріуса з нотаріального посвідчення статутних документів.

      </section>
      </TextBlock>


      <TextBlock name= 'Пакет "Максимальний"'>
      <section className="s-text">
        
          При замовлені цього пакету, окрім послуг, котрі входять в попередні пакети, вам буде надано: <br/>
          1) допомога під час відкриття рахунку в банку; <br/>
          2) допомога в отримані електронного цифрового підпису. <br/>
          3) печатка. <br/>
       
      </section>
      <section className="s-textb">
         Строк виконання – до 10 робочих днів. <br/>
          Вартість – 8000 грн. <br/>
         *Вартість послуги зазначено для фірм що реєструються за київською адресою і до складу засновників яких входить не більше 2х засновників,  якщо засновників  більше двох, то вартість збільшується на 200 грн. <br/>
          Додатково оплачуються послуги нотаріуса з нотаріального посвідчення статутних документів.
       </section>
      </TextBlock>

    </React.Fragment>
  );
}

const L2 = (props) => {
  return (
    <TextBlock name='Окремі послуги в сфері реєстрації юридичних осіб:'>
    <section className="s-textb">
      Консультація – від 500 гривень; <br/>
      підготовка статутних документів – від 1500 гривень; <br/>
      подача документів державному реєстратору – 2000 гривень;  <br/>
      печатка – 600 гривень; <br/>
      допомога в отримані цифрового підпису - 1000 гривень; <br/>
      реєстрація на спрощену систему оподаткування – 1000 гривень; <br/>
      реєстрація платником ПДВ – 1000 гривень; <br/>
      витяг з єдиного державного реєстру – 600 гривень; <br/>
      витяг з реєстру платників ПДВ або ЄП – 600 гривень; <br/>
      підготовка внутрішніх протоколів і наказів – від 500 гривень; <br/>
      супровід відкриття рахунку в банку 1000 гривень.
    </section>
  </TextBlock>

  );
}

const L3 = (props) => {
  return (
    <TextBlock name='Реєстрація неприбуткових організацій (благодійних фондів, громадських організацій)'>
    <section className="s-text">
        Ми з радістю допоможемо вам зареєструвати неприбуткову організацію. В послугу входить:<br/>
        1) консультація; <br/>
        2) розробка статутних документів; <br/>
        3) державна реєстрація; <br/>
        4) отримання печатки; <br/>
        5) за потреби, отримання статусу неприбутковості (до 14 днів); <br/>
      
    </section>
    <section className="s-textb">
      Строк виконання: <br/>
      для фондів 3-5 робочих днів <br/>
      для ГО до 14 робочих днів <br/>
      Вартість 4000 гривен
    </section>
  </TextBlock>
  );
}

export { L1, L2, L3 };


// WEBPACK FOOTER //
// ./src/Page/L1-L3.jsx